export default "__VITE_ASSET__CsYxcmBx__"